import * as Yup from 'yup'

import { CNPJValidator } from '../../../utils'

export default Yup.object().shape({
    cnpj: Yup.string().required('CNPJ é obrigatório!').test('CNPJ', 'Digite um CNPJ válido!', CNPJValidator.validate),
    companyName: Yup.string().required('Empresa é obrigatório!'),
    target: Yup.number().typeError('Insira um número válido!').integer('Insira um número válido!').positive('Insira um número válido!').required('Default criteria é obrigatório!'),
    gracePeriod: Yup.number().typeError('Insira um número válido!').integer('Insira um número válido!').positive('Insira um número válido!').required('Grace period é obrigatório!'),
    tolerableTicketsQty: Yup.number().nullable(),
    tolerableTicketsValuePercentage: Yup.number().nullable(),
    parserFileName: Yup.string().required('Arquivo do parser é obrigatório!'),
    modelFileName: Yup.string().required('Arquivo do modelo é obrigatório!')
}) 